import type {CSSProperties} from "react";
import cn from "classnames";
import "./index.css";
import BgTransformer from "../../../layout/BgTransformer";
import ContentEditable from "../../../layout/ContentEditable/ContentEditable";
import ImageUpload from "../../../layout/ImageUpload";
import PixelationLayer from "../../../layout/PixelationLayer";
import {useSetting} from "../../../contexts/setting";
import {useEdits} from "../../../contexts/edits";
import {useBgUrl} from "../../../hooks/useBgUrl";
import {useLogoUrl} from "../../../hooks/useLogoUrl";
import {checkIfIDE} from "../../../data/products/index";

interface DotNetSplashLayoutLegacyProps {
  id: string;
  zoom: number;
  scale: 1 | 2;
  fallbackTransformId: string;
}

/** The previous .NET design, restored under its own Archive identities. */
const DotNetSplashLayoutLegacy = ({id, zoom, scale, fallbackTransformId}: DotNetSplashLayoutLegacyProps) => {
  const {product, type, layoutOption} = useSetting();
  const {url: bgUrl} = useBgUrl();
  const {versions, productNames}: {
    versions: Record<string, string | undefined>;
    productNames: Record<string, string | undefined>;
  } = useEdits();
  const productName = productNames[id] || productNames.main || product.altLabel || product.label;
  const version = versions[id] ?? versions.main ?? "2025.3";
  const logoSrc = useLogoUrl(id);
  const style = {"--zoom-level": zoom, "--dotnet-splash-scale": scale} as CSSProperties;

  return (
    <div id={id} className={cn("template", "dotnet-splash-legacy", {"dotnet-splash-legacy-2x": scale === 2}, product.value, `layout-${layoutOption}`)} style={style}>
      <div>
        <BgTransformer src={bgUrl} id={id} fallbackTransformId={fallbackTransformId} />
        <PixelationLayer scale={scale} />
        <div className="content">
          <div className="product-name">
            <ContentEditable id={id} text={productName} />
          </div>
          <div className="version">
            <div className="textarea">
              <ContentEditable id={id} text={version} />
            </div>
          </div>
          <header className="template-header">
            <div className={cn("logo", {ide: checkIfIDE(product.value, type.value)})}>
              <img src={logoSrc} alt="logo" />
            </div>
          </header>
        </div>
        {[5, 6].includes(Number(layoutOption)) && (
          <div className="upload-wrap"><ImageUpload id={id} /></div>
        )}
      </div>
    </div>
  );
};

export default DotNetSplashLayoutLegacy;
